import { useMediaQuery } from '@wp-g2/utils';
import React from 'react';
import { BREAKPOINTS, getBreakpointValue } from './Viewport.utils';
export function Viewport(_ref) {
  var _ref$breakpoint = _ref.breakpoint,
      breakpoint = _ref$breakpoint === void 0 ? 'md' : _ref$breakpoint,
      children = _ref.children,
      media = _ref.media;
  var visible = useMediaQuery(media || getBreakpointValue(breakpoint));
  return visible ? children : null;
}
export function ViewportMobile(props) {
  return /*#__PURE__*/React.createElement(Viewport, Object.assign({}, props, {
    media: {
      maxWidth: BREAKPOINTS.xs
    }
  }));
}
export function ViewportPhablet(props) {
  return /*#__PURE__*/React.createElement(Viewport, Object.assign({}, props, {
    breakpoint: "sm"
  }));
}
export function ViewportPhabletOnly(props) {
  var media = {
    maxWidth: BREAKPOINTS.md,
    minWidth: BREAKPOINTS.sm
  };
  return /*#__PURE__*/React.createElement(Viewport, Object.assign({}, props, {
    media: media
  }));
}
export function ViewportTablet(props) {
  return /*#__PURE__*/React.createElement(Viewport, Object.assign({}, props, {
    breakpoint: "md"
  }));
}
export function ViewportTabletOnly(props) {
  var media = {
    maxWidth: BREAKPOINTS.lg,
    minWidth: BREAKPOINTS.md
  };
  return /*#__PURE__*/React.createElement(Viewport, Object.assign({}, props, {
    media: media
  }));
}
export function ViewportDesktop(props) {
  return /*#__PURE__*/React.createElement(Viewport, Object.assign({}, props, {
    breakpoint: "lg"
  }));
}